import React from 'react';
import ChatWithUs from '../ChatWithUs';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { IChatWithUsProps } from '../ChatWithUs.props';

const rehydrator: RehydratorFunction = async (domNode) => {
  const props: IChatWithUsProps = elementAttributesToProps(domNode);

  return Promise.resolve(<ChatWithUs {...props} />);
};

export default rehydrator;
